<template lang="pug">
  .services-list.ui-color-3-bg
    .inner-wrap
      .section-header.mb-200m
        h2.xs-f-grande.md-f-xxgrande.max-at-tweak.kapra-neue.brand-color-1 {{ title }}
        a.mr-btn.all-btn.xs-f-medium.md-f-xsmall(href="/haircolorbar/services" @click.prevent="goToServices") See all

      .list
        .service(v-for="service in services" :key="service.code")
          .top-wrap
            .image-wrap.mb-100m.a-box-md-1x1.a-box-xs-10x9
              .a-box-content
                ImgBox(:media-obj="service.image")

            .service-name.xs-f-xmedium.md-f-small.max-at-tweak.cw-color-11.bold {{ service.name }}
            .service-desc.xs-f-small.md-f-xsmall.max-at-tweak.text-color-2 {{ service.description }}

          button.mr-btn.btn-block.mt-100m(@click="handleBookNow(service.code)") Book now

</template>
<script>
  import { mapState } from 'vuex';
  import ImgBox from '@components/imgBox.vue';

  export default {
    name: "ServicesList",

    components: {
      ImgBox
    },

    props: {
      title: {
        type: String,
        default: 'Our Services'
      },
      services: {
        type: Array,
        default: () => ([])
      },
      location: {
        type: Object,
        default: () => ({})
      }
    },

    computed: {
      ...mapState('customer', ['cdata']),

      bookUrl() {
        let url = '/colorbar/locations';
        if (this.location?.code) {
          url = `/colorbar/booking/${this.location.code}/services`;
        }

        return url;
      },

      hadAppointment() {
        return this.cdata?.hasBookedAppointment;
      }
    },

    methods: {
      goToServices() {
        this.trackMREventAndRedirect('HCB Location Page - See all services clicked', '/haircolorbar/services');
      },

      handleBookNow(code) {
        if (!this.hadAppointment) {
          code = code.replace('_only', '');
          code += '_consult';
        }

        this.$cookies.set('selected_service', code);
        let url = this.bookUrl;
        this.trackMREventAndRedirect(`HCB Location Page Services - Book Service clicked`, url);
      }
    }
  };
</script>

<style lang="stylus" scoped>
  .services-list
    letter-spacing -0.01em
    padding 3em 1.3em

    @media mq-desktop-plus
      padding 4.5rem 3.25em 3rem 3.25rem

    .inner-wrap
      flex-direction column

    .section-header
      display flex
      justify-content space-between
      align-items center
      width 100%

      @media mq-tablet-less
        display flex
        flex-direction column
        gap 2em

      .all-btn
        text-transform none
        background-color transparent
        border 1px ui-color-5 solid
        color cw-color-11
        border-radius 8px
        height fit-content
        letter-spacing -0.5px

        @media mq-tablet-less
          width 100%

    .list
      display flex
      flex-wrap wrap
      justify-content center
      margin 0 -0.9rem
      @media mq-tablet-less
        display flex
        flex-direction column
        margin unset

      .service
        display flex
        flex-direction column
        align-items center
        justify-content space-between
        padding 1rem 0.5rem
        width 100%

        @media mq-desktop-md
          padding 1rem 0.9rem
          width 30%

        @media mq-desktop-plus
          padding 1rem 0.9rem
          width 20%

        .top-wrap
          display flex
          flex-direction column
          align-items center

          .a-box-content
            padding 1.8rem 1.5rem

            @media mq-desktop-md-plus
              padding 1.4rem 0

          .service-name
            width 100%
            text-align left

          .image-wrap
            width 100%
            border-radius 20px
            overflow hidden
            background-color white

            img
              max-width 100%
              width 100%
              display block
</style>
